import script from "./Download.vue?vue&type=script&lang=ts&setup=true"
export * from "./Download.vue?vue&type=script&lang=ts&setup=true"

import "./Download.vue?vue&type=style&index=0&id=89953a8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89953a8c"]])

export default __exports__